// src/components/HealthBarChart.jsx
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const Chart12Month = ({ data }) => {
  return (
    <div className="h-56 bg-white shadow-lg rounded-xl p-3">
      <span className="text-md font-semibold block mb-2">Records from last 12 months</span>
      <ResponsiveContainer width="100%" height="85%">
        <BarChart data={data} margin={{ top: 20, right: 20, bottom: 10, left: 10 }}>
          <XAxis
            dataKey="month"
            angle={-30}
            textAnchor="end"
            interval={0}
            tick={{ fontSize: 11 }}
          />
          <YAxis hide />
          <Tooltip />
          <Bar dataKey="records" fill="#3b82f6">
            <LabelList
              dataKey="records"
              position="top"
              content={({ value, x, y, width }) =>
                value > 0 ? (
                  <text
                    x={x + width / 2}
                    y={y - 6}
                    fill="#000"
                    textAnchor="middle"
                    fontSize={12}
                    fontWeight="bold"
                  >
                    {value}
                  </text>
                ) : null
              }
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Chart12Month;
